// import React from "react";
// import { Box, Typography } from "@mui/material";
// import { ProductStyles } from "../Products/Styles";
// import UMVideo from "../../assets/video/UnderMaintenance.mp4";

// const GlobalLaunching = () => {
//   return (
//     <Box sx={ProductStyles.MainBannerBox}>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           my: 4,
//         }}
//       >
//         <Box
//           component="img"
//           alt=""
//           src="images/ComingSoon.png"
//           sx={{
//             width: {
//               xs: "40%", // Mobile
//               sm: "25%", // Small tablets
//               md: "25%", // Medium devices
//               lg: "25%", // Large desktops
//               xl: "25%", // Extra large screens
//             },
//             maxWidth: "100%",
//             height: "auto",
//             display: "block",
//           }}
//         />

//         <Box>
//           <Typography
//             variant="h6"
//             sx={{
//               fontSize: { xs: "1.4rem", sm: "1.4rem", md: "1.9rem" },
//               fontFamily: '"Poppins", serif',
//               fontWeight: 600,
//             }}
//           >
//             Launching Soon 🚀
//           </Typography>
//         </Box>

//         <Box>
//           <Typography variant="body" sx={{ fontFamily: '"Poppins", serif' }}>
//             We're working hard to bring something amazing. Stay tuned!
//           </Typography>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default GlobalLaunching;
import React from "react";
import { Box } from "@mui/material";
import { BannerStyles } from "../Styles";

const GlobalLaunching = () => {
  return (
    <Box sx={{ padding: "0px 0px" }}>
      <Box
        sx={[
          BannerStyles.bannerBox,
          { height: { xs: "25vh", sm: "25vh", md: "70vh", lg: "70vh" } },
        ]}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            height: "auto",
            width: "95%",
            border: "1px solid #cfd8dc",
          }}
        >
          <source
            src={"/images/UnderMaintenance.mp4"}
            type="video/mp4"
            width={"100%"}
          />
        </video>
      </Box>
    </Box>
  );
};

export default GlobalLaunching;
